import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledBadgeContainer = styled(Flex)<{ $isClickable?: boolean }>`
    white-space: nowrap;
    border: 1px solid ${colorsPalettes.bluegrey["300"]};
    cursor: ${({ $isClickable }) => ($isClickable ? "pointer" : "default")};
    ${({ $isClickable }) =>
        $isClickable &&
        css`
            &:hover {
                background: ${colorsPalettes.blue[200]};
                border: 1px solid ${colorsPalettes.blue[200]};
            }
        `}
`;
